import { render, staticRenderFns } from "./FormLayoutVerticalIcon.vue?vue&type=template&id=ae6a1446&"
import script from "./FormLayoutVerticalIcon.vue?vue&type=script&lang=js&"
export * from "./FormLayoutVerticalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports